import React from 'react'
import ControlSwimlaneTasks from './ControlSwimlaneTasks'
import { createTask } from '../../flux/tasks/TaskActions'
import { ISwimlaneView } from './ControlSwimlane'
import Dropdown from 'react-bootstrap/Dropdown'
import VerticalDotDropdownToggle from '../bootstrap-extensions/VerticalDotDropdownToggle'
import styles from './Swimlane.module.scss'

/**
 * Properties expected by the Swimlane Component
 */
export interface ISwimlaneProps {
    boardId: number
    swimlane: ISwimlaneView
    canMove: boolean
    onEdit: () => void
    onDelete: () => void
    onMove: () => void
    onDrop: (event: React.DragEvent) => void
    onDragEnter: (event: React.DragEvent) => void
    onDragOver: (event: React.DragEvent) => void
}

function SwimlaneComponent(props: ISwimlaneProps) {
    return (
        <div className={`card h-100 mb-5 ${styles.card}`}>
            <div className={`card-header d-flex ${styles.header}`}>
                <div className="flex-grow-1 align-self-center text-primary">
                    <h6 className="mb-0">{props.swimlane.name}</h6>
                </div>
                <div>
                    <Dropdown drop="left">
                        <Dropdown.Toggle
                            as={VerticalDotDropdownToggle}
                            className="text-primary"
                        />
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={props.onDelete}>
                                Delete
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={props.onMove}
                                disabled={!props.canMove}>
                                Move
                            </Dropdown.Item>
                            <Dropdown.Item onClick={props.onEdit}>
                                Edit
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={() =>
                                    createTask(props.boardId, props.swimlane.id)
                                }>
                                Add Task
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>
            <div
                className="card-body"
                aria-label="Task List"
                onDrop={props.onDrop}
                onDragEnter={props.onDragEnter}
                onDragOver={props.onDragOver}>
                <ControlSwimlaneTasks
                    boardId={props.boardId}
                    swimlaneId={props.swimlane.id}
                    taskIds={props.swimlane.taskIds}
                />
            </div>
        </div>
    )
}

export default SwimlaneComponent
